export const education = [
  {
    id: 1,
    institution: 'Sheffield Hallam University',
    degree: 'Executive-Masters in Business Administration (MBA)',
    field: 'Majoring in Finance and Economics',
    period: 'Sep 2024 - Aug 2027',
    activities: 'Executive-Masters in Business Administration (MBA)',
    skills: [
      'Business Administration',
      'Executive Management',
      'Strategic Planning',
      'Project Management',
      'Operations Management',
    ],
  },
  {
    id: 2,
    institution: 'University of Botswana (UB)',
    degree: 'Master of Science in Computer Science',
    field: 'Software Engineering (Design Patterns & Architecture) and Artificial Intelligence',
    period: 'Jul 2024 - Aug 2026',
    activities:
      'Artificial Intelligence, Machine Learning, Project Management, Dissertation, Thesis Writing',
    skills: [
      'Agile Methodologies',
      'Project Management',
      'Machine Learning',
      'Programming',
      'Artificial Intelligence (AI)',
      'Cloud Application Development',
    ],
  },
  {
    id: 3,
    institution: 'University of Sunderland',
    degree: 'BSc (Hons) Computer Systems Engineering',
    field: 'Computer Systems Engineering',
    period: 'Aug 2020 - Jun 2024',
    grade: 'First Class Honors Degree',
    activities: 'Computing Student | Mobile Developer | Software Engineer',
    skills: [
      'Agile Methodologies',
      'Project Management',
      'Software Project Management',
      'Dissertation Editing',
      'Programming',
      'Cloud Application Development',
    ],
  },
];
